import React, { Component } from 'react'

import Breadcrumbs from '../block/Breadcrumbs'
import Stati from '../block/Stati'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <Breadcrumbs breadcrumbs={data?.breadcrumbs || []} />
        <Stati data={data} more={2} />
        <Faq data={data} />
      </>
    )
  }
}

export default App